import React, { useEffect } from "react";
import "./Withdraw.scss";
import Select from "react-select";
import StatisticTable from "../../../../components/StatisticTable/StatisticTable";
import {
  customStylesSelect,
  loaderOverride,
  totalsRanges,
} from "../../../../utils/constants/constants";
import TotalRangePicker from "../../../../components/TotalRangePicker/TotalRangePicker";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import useWithdraw from "./hooks/useWithdraw";
import WithdrawLegend from "../../../../components/WithdrawLegend/WithdrawLegend";
import WithdrawItem from "../../../../components/WithdrawItem/WithdrawItem";

const Withdraw = () => {
  const {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    data,
    showRangePicker,
    dataACH,
    dataWire,
    setSelectorValue,
    getWithdrawalsData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
  } = useWithdraw();
  const { USDTable, BTCTable, USDACHTable, USDWireTable, totalTable } =
    useTableContent(data, dataACH, dataWire);

  useEffect(() => {
    if (filterTypeSaved && filterTypeSaved !== "null") {
      setSelectorValue(filterTypeSaved);
      getWithdrawalsData(fromSaved, toSaved);
    } else if (filterTypeSaved === "null" && fromSaved) {
      setSelectorValue("customized");
      getWithdrawalsData(fromSaved, toSaved);
    } else {
      getWithdrawalsData(fromDate, toDate);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      if (selectorValue === "customized") {
        setSelectorValue("customized");
        return setShowRangePicker(true);
      }

      if (selectorValue) {
        const range = getDateRange(selectorValue);
        getWithdrawalsData(range.startDate, range.endDate);
      }
    }
  }, [selectorValue]);

  if (isLoading) {
    return (
      <div className="withdraw__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="withdraw__wrapper">
      <div className="withdraw__tables">
        <StatisticTable data={totalTable} />
        <StatisticTable data={USDTable} />
        <StatisticTable data={USDWireTable} />
        <StatisticTable data={USDACHTable} />
        <StatisticTable data={BTCTable} />
      </div>
      <div className="withdraw__selector-wrapper">
        <span className="withdraw__selector-label">Period</span>
        <Select
          styles={customStylesSelect}
          options={totalsRanges}
          placeholder={"placeholder"}
          getOptionValue={(option) => option.value}
          onChange={(option) => {
            if (
              option.value === "customized" &&
              selectorValue === "customized"
            ) {
              setShowRangePicker(true);
            }

            setSelectorValue(option.value);
          }}
          value={totalsRanges.find((option) => option.value === selectorValue)}
        />
      </div>
      <div className="withdraw__items-table">
        <WithdrawLegend />
        {data?.grouped
          ? Object.entries(data?.grouped)
              ?.reverse()
              ?.map((el) => (
                <WithdrawItem
                  el={el}
                  key={el[0]}
                  dataACH={dataACH}
                  dataWire={dataWire}
                />
              ))
          : null}
      </div>
      {showRangePicker && (
        <TotalRangePicker
          showModal={showRangePicker}
          setShowModal={setShowRangePicker}
          getData={getWithdrawalsData}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  );
};

export default Withdraw;
